import React, { useRef, useEffect, useState } from 'react';
import {
  Container,
  Grid,
  TextField,
  Typography,
  IconButton,
  Button,
} from '@mui/material';
import { Autocomplete } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useStateValue } from '../../../contexto/store';
import style from '../../Tools/Style';
import ModalClientes from '../../GestionDeClientes/ModalClientes';
import NumberFormat from 'react-number-format';
import { obtenerClientes } from '../../../actions/ClientesAction';
import moment from 'moment';
import { obtenerListaUsuarios } from '../../../actions/UsuariosAction';
import { registrarFactura } from '../../../actions/CobranzasAction';
import { RegistrarAccion } from '../../../actions/AuditoriaAction';

function NumberFormatCustom(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={(values) => {
        onChange({
          target: {
            name: props.name,
            value: values.value,
          },
        });
      }}
      thousandSeparator="."
      decimalSeparator={false}
      isNumericString
    />
  );
}
export default function NuevaFactura(props) {
  const mounted = useRef(true);
  //eslint-disable-next-line
  const [{ sesionUsuario }, dispatch] = useStateValue();
  const [usuario, setUsuario] = useState('');
  const [asignar, setAsignar] = useState(false);
  const [dataUsu, setDataUsu] = useState([]);
  const [modalBuscar, setModalBuscar] = useState(false);
  const [Datacl, setDatacl] = useState([]);
  const [factura, setFactura] = useState({
    nrocomprobante: '',
    usuario: '',
    cliente: '',
    timbrado: '',
    fechacomprobante: '',
    fechavencimiento: '',
    total: 0,
    cliente_id: '',
    usuario_id: '',
  });
  const abrirModal = () => {
    setModalBuscar(true);
  };
  const cerrarModal = () => {
    setModalBuscar(false);
  };
  const ingresarValoresMemoria = (e) => {
    const { name, value } = e.target;
    setFactura((anterior) => ({
      ...anterior,
      [name]: value,
    }));
  };
  const nuevaFactura = () => {
    if (
      factura.nrocomprobante !== '' &&
      factura.total !== 0 &&
      factura.fechavencimiento !== '' &&
      factura.fechavencimiento !== 'Invalid date' &&
      factura.fechacomprobante !== '' &&
      factura.fechacomprobante !== 'Invalid date' &&
      factura.timbrado !== '' &&
      factura.cliente_id !== ''
    ) {
      let objeto = {
        nrocomprobante: factura.nrocomprobante,
        totalfactura: parseInt(factura.total),
        timbrado: factura.timbrado,
        fechacomprobante: moment(factura.fechacomprobante).format(),
        fechavencimiento: moment(factura.fechavencimiento).format(),
        UserName: sesionUsuario.usuario.userName,
        cliente_id: factura.cliente_id,
      };
      registrarFactura(objeto).then((response) => {
        if (response.status === 200) {
          dispatch({
            type: 'OPEN_SNACKBAR',
            openMensaje: {
              open: true,
              mensaje: 'Se registro la factura con exito',
            },
          });
          setFactura({
            nrocomprobante: '',
            usuario: sesionUsuario.usuario.nombrecompleto,
            cliente: '',
            timbrado: '',
            fechacomprobante: '',
            fechavencimiento: '',
            total: 0,
            cliente_id: '',
            usuario_id: '',
          });
          let objetoAudi = {
            usuario: sesionUsuario.usuario.nombrecompleto,
            accion: 'Registro',
            panel: 'Gestion de Cobranzas',
            tabla: 'FACTURAS',
            filaafectada: 'NUEVO REGISTRO',
            UsuarioId: sesionUsuario.usuario.id,
          };
          RegistrarAccion(objetoAudi);
        }
      });
    } else {
      dispatch({
        type: 'OPEN_SNACKBAR',
        openMensaje: {
          open: true,
          mensaje: 'Todos los campos son obligatorios',
        },
      });
    }
  };
  const seleccionarCliente = (cliente) => {
    const id = cliente.clientE_Id;
    setFactura({
      nrocomprobante: factura.nrocomprobante,
      usuario: factura.usuario,
      cliente: cliente.nombre + ' ' + cliente.apellido,
      timbrado: factura.timbrado,
      fechacomprobante: factura.fechacomprobante,
      fechavencimiento: factura.fechavencimiento,
      total: factura.total,
      cliente_id: id,
      usuario_id: factura.usuarioId,
    });
    setModalBuscar(false);
  };
  const volver = () => {
    props.history.goBack();
  };
  useEffect(() => {
    if (mounted.current) {
      if (props.location.state) {
        obtenerListaUsuarios().then((response) => {
          if (response.status === 200) {
            setDataUsu(response.data);
          } else {
            console.log('NO TRAJO USUARIOS');
          }
        });
        setAsignar(true);
      } else {
        setAsignar(false);
      }
      obtenerClientes().then((response) => {
        if (response.status === 200) {
          setDatacl(response.data);
        }
      });
      setFactura({
        nrocomprobante: factura.nrocomprobante,
        usuario: sesionUsuario.usuario.nombrecompleto,
        cliente: factura.cliente,
        timbrado: factura.timbrado,
        fechacomprobante: factura.fechacomprobante,
        fechavencimiento: factura.fechavencimiento,
        total: factura.total,
        cliente_id: factura.cliente_id,
        usuario_id: factura.usuarioId,
      });
    }
    return function cleanup() {
      mounted.current = false;
    };
  }, [props, factura, sesionUsuario, usuario]);
  return (
    <Container jsutify="center" maxWidth="md">
      <br />
      <Typography align="center" variant="h6">
        Nueva Factura
      </Typography>
      <br />
      <Grid container spacing={4}>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            name="nrocomprobante"
            onChange={ingresarValoresMemoria}
            value={factura.nrocomprobante}
            label="Numero Factura"
          />
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          {asignar ? (
            <Autocomplete
              id="combo-box-demo"
              options={dataUsu}
              getOptionLabel={(dataUsu) => dataUsu.nombrecompleto}
              renderInput={(params) => (
                <TextField
                  fullWidth
                  {...params}
                  label="Buscar Usuarios"
                  variant="outlined"
                />
              )}
              onChange={(e, value) => {
                if (value === null) {
                  setUsuario('');
                } else {
                  setUsuario(value.nombrecompleto);
                }
              }}
            />
          ) : (
            <TextField
              fullWidth
              variant="outlined"
              name="usuario"
              value={factura.usuario}
              label="Usuario"
            />
          )}
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            name="timbrado"
            onChange={ingresarValoresMemoria}
            value={factura.timbrado}
            label="Timbrado"
          />
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            name="total"
            onChange={ingresarValoresMemoria}
            value={factura.total}
            label="Total de la Factura"
            InputProps={{
              inputComponent: NumberFormatCustom,
            }}
          >
            Total de la Factura
          </TextField>
          <br />
        </Grid>
        <IconButton
          onClick={abrirModal}
          style={style.iconbutton}
          aria-label="buscar"
        >
          <SearchIcon />
        </IconButton>
        <Grid style={style.textTarea}>
          <TextField
            disabled={true}
            name="CLIENTE"
            value={factura.cliente}
            multiline
            fullWidth
            variant="outlined"
            label="CLIENTE"
          />
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            name="fechacomprobante"
            value={factura.fechacomprobante}
            label="Fecha del comprobante"
            onChange={ingresarValoresMemoria}
            type="date"
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <TextField
            fullWidth
            variant="outlined"
            name="fechavencimiento"
            value={factura.fechavencimiento}
            label="Fecha de vencimiento"
            onChange={ingresarValoresMemoria}
            type="date"
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <Button
            style={style.submit}
            variant="contained"
            color="primary"
            onClick={nuevaFactura}
          >
            Guardar
          </Button>
        </Grid>
        <Grid item lg={6} md={6} sm={12} xs={12}>
          <Button
            style={style.submit}
            variant="contained"
            color="primary"
            onClick={volver}
          >
            Volver
          </Button>
        </Grid>
      </Grid>
      <Grid container direction="row" justify="center" alignItems="center">
        <ModalClientes
          data={Datacl}
          open={modalBuscar}
          handleClose={cerrarModal}
          seleccionarCliente={seleccionarCliente}
        />
      </Grid>
    </Container>
  );
}
